import {cssTheme} from '@yandex-delivery/blocks/theme'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const addressesContainer = css`
  max-height: ${spacing(28)}; // 224px;
  overflow-y: auto;
`

export const header = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-height: ${spacing(2.5)}; // 20px;
`

export const closeButton = css`
  position: relative;
  right: -${spacing(1.5)};
`

export const pointAddress = css`
  inline-size: calc(100% - ${spacing(7)}); // 100% - 56px
`

export const footer = css`
  box-shadow: ${cssTheme.shadows.topNormal};
  margin-block-start: ${spacing(2)} !important;
  padding-block-start: ${spacing(1)};
`

export const image = css`
  padding: ${spacing(1)};
`

export const truncatedText = css`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const fullscreenRouteInfoContainer = css`
  height: 100vh;
`

export const fullscreenAddressesContainer = css`
  max-height: unset;
  height: calc(100vh - var(--components-slots-size-l) - ${spacing(10.5)}); // вся страница без хедера и кнопки
`
